import {
  AcceptedValuesResourceTypes,
  IAttributeDefinition,
  IAttributeValidationDynamicAcceptedValues,
  IAttributeValidationStaticAcceptedValues,
  IPayeeEngagementResponse,
  IPayerEngagementResponse
} from "@wingspanhq/payments/dist/interfaces";
import get from "lodash/get";

export function isDynamicEnumConfig(
  config:
    | IAttributeValidationStaticAcceptedValues
    | IAttributeValidationDynamicAcceptedValues
): config is IAttributeValidationDynamicAcceptedValues {
  return (
    "resourceType" in config &&
    "valuePath" in config &&
    "acceptedValues" in config
  );
}

export function isStaticEnumConfig(
  config:
    | IAttributeValidationStaticAcceptedValues
    | IAttributeValidationDynamicAcceptedValues
): config is IAttributeValidationStaticAcceptedValues {
  return "acceptedValues" in config;
}

export type AcceptedValuesResources = {
  payerPayeeEngagement?: IPayerEngagementResponse | IPayeeEngagementResponse;
};

export function getEnumValues(
  definition: IAttributeDefinition,
  resources: AcceptedValuesResources
) {
  const config = definition.validationRules?.enumConfig;
  if (!config) {
    return [];
  }

  if (isDynamicEnumConfig(config)) {
    let resource: Record<string, any>;
    switch (config.resourceType) {
      case AcceptedValuesResourceTypes.PayerPayeeEngagement:
        if (!resources.payerPayeeEngagement) {
          console.error(
            "PayerPayeeEngagement is required for dynamic enum values"
          );
          return [];
        }
        resource = resources.payerPayeeEngagement;
        break;
    }

    const values = get(resource, config.valuePath);

    return Array.isArray(values) ? values : [values];
  }

  if (isStaticEnumConfig(config)) {
    return config.acceptedValues || [];
  }

  return [];
}
